<template>
  <div class="login-container">
    <div class="login-bg">
      <img src="../images/1366-bg.png" alt="" />
    </div>

    <!-- 登录表单 -->
    <div class="form-wrap">
      <div class="login-log">
        <span>登录LOGIN</span>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="phone">
          <div class="login-user">
            <img src="../images/user.png" alt="" />
          </div>
          <el-input
            v-model="loginForm.phone"
            placeholder="请输入登录账号"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <div class="login-pass">
            <img src="../images/me.png" alt="" />
          </div>
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            class="top"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <!-- 登录按钮 -->
      <div class="form-foot">
        <el-button type="primary" round v-debounce="submitLogin"
          >登 录</el-button
        >
      </div>
      <!-- 提醒 -->
      <div class="login-remind">
        <img src="../images/dengpao.png" alt="" />
        <span>  如果忘记了账号/密码，可以联系班主任找回</span>
      </div>
    </div>
    <p class="copy-right">Copyright©上海松鼠课堂人工智能科技有限公司.<a href="https://beian.miit.gov.cn/">沪ICP备15050242号-1</a></p>
  </div>
</template>

<script>
/* eslint-disable */
import { getSign } from '@/pages/dl-web/utils/verify';
import {
  getUAString, getOSInfo,
  getBrowserInfo, getFlashVersion,
  getCookieEnable, getLocalStorageEnable, getUrlVia,
} from '@/pages/dl-web/utils/index';
import api from '@/pages/dl-web/api/api';

export default {
  data() {
    return {
      rules: {
        phone: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      client_params: {}, // 客户端参数
      loginForm: {
        phone: '',
        password: '',
        time_stamp: '',
      },
    };
  },
  directives: {
    debounce: {
      inserted(el, binding) {
        let timer;
        el.addEventListener('click', () => {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            binding.value();
          }, 400);
        });
      },
    },
  },
  methods: {
    // 提交登录
    submitLogin() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.client_params = {
            user_agent: getUAString(), // 用户代理
            user_system: getOSInfo(), // 用户系统信息
            user_browser: getBrowserInfo(), // 用户浏览器信息
            user_flash_version: getFlashVersion(), // Flash 版本号
            user_cookie_status: getCookieEnable() ? 2 : 1, // 用户cookie状态:1未开启2开启
            user_js_version: '2.5.2', // 用户JavaScript版本
            user_js_status: 2, // 用户JavaScript状态:1未开启2开启
            user_ls_status: getLocalStorageEnable() ? 2 : 1, // 用户本地存储LocalStorage 状态:1未开启2开启
            user_cache: document.cookie, // 用户cookie信息
          };
          // 用户via
          getUrlVia(window.location.href, (data) => {
            this.client_params.user_via = data;
          });
          const params = {
            phone: this.loginForm.phone,
            password: this.loginForm.password,
            client_params: JSON.stringify(this.client_params),
          };
          params.time_stamp = (new Date()).getTime();
          params.sign = getSign(params);
          const res = await api.LoginData(params);
          console.log(res);
          if (res) {
            if (res.code === 0) {
              this.$toast('登录成功');
              setTimeout(() => {
                this.$router.push({
                  path: '/dl-web/detail',
                });
              }, 2000);
              if (res.data.type === 10) {
                this.loginUpUser.user_id = res.data.user_id;
                // this.upUserVisible = true
              } else {
                this.$toast('登录成功');
              }
              document.onkeydown = undefined;
              localStorage.setItem('real_name', res.data.user_info.real_name);
              sessionStorage.setItem('channel', res.data.channel || 'url');
              localStorage.setItem('token', res.data.yx_token);
            }else{
              this.$toast(res.msg)
            }
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  width: 100%;
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
  .login-bg img {
    height: 100%;
    flex: 1;
  }
  .form-wrap {
    // flex: 1;
    height: 100%;
    position: relative;
    margin: 259px auto;
    font-family: PingFangSC-Semibold, PingFang SC;
    // padding-left: 112px;
    .login-log {
      font-size: 26px;
      font-weight: 600;
      color: #6d7278;
      position: absolute;
      top: -66px;
    }
    .login-user {
      position: absolute;
      top: 19px;
      left: 27px;
      z-index: 99;
       img {
        width: 20px;
        height: 24px;
      }
    }
    .login-pass {
      position: absolute;
      top: 39px;
      left: 28px;
      z-index: 99;
       img {
        width: 20px;
        height: 24px;
      }
    }
    .top {
      margin-top: 20px;
    }
    .login-remind {
      font-size: 14px;
      font-weight: 400;
      color: rgba(17, 31, 44, 0.4);
      margin-top: 26px;
      padding-left: 30px;
      img {
        margin-bottom: -5px;
        margin-right: 2px;
        width: 20px;
        height: 24px;
      }
    }
  }
  ::v-deep {
    .el-input {
      font-family: PingFangSC-Regular, PingFang SC;
      .el-input__inner {
        width: 360px;
        height: 66px;
        background: #ffffff;
        border-radius: 33px;
        border: 1px solid rgba(138, 123, 201, 0.6);
        font-size: 17px;
        font-weight: 400;
        color: #8b99a9;
        line-height: 66px;
        padding-left: 66px;
      }
    }
    .el-form-item__error {
      font-size: 16px;
      padding-left:28px ;
      padding-top: 10px;
    }
    .el-button {
      width: 360px;
      height: 66px;
      border: none;
      background: linear-gradient(180deg, #bb9fff 0%, #8566ff 100%);
      box-shadow: 0px 2px 6px 0px #b1a2ed;
      border-radius: 48px;
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      letter-spacing: 1px;
      margin-top: 25px;
    }
  }
}
</style>
